export enum RequestStatus {
    S="STARTED",
    AN="ANALYSING",
    R="RETURNED",
    AP="APPROVED",
    D="DENIED"
}